import Link from 'next/link';
import LogoInverse from './LogoInverse';

const FOOTER_LINK_CLASSES =
  'text-default-100 underline-offset-4 transition-colors duration-200 hover:text-default-300 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-default-100';

export default function MarketingFooter() {
  const columns = [
    {
      title: 'About',
      items: [
        { label: 'For Patients', href: '/about/patients' },
        { label: 'For Providers', href: '/about/providers' },
        { label: 'For Biopharma', href: '/about/sponsors' },
        { label: 'Sponsors Directory', href: '/directory' },
        { label: 'Browse by Cancer Type', href: '/cancer-type' },
        { label: 'Social Impact', href: '/about/social-impact' },
      ],
    },
    {
      title: 'Help',
      items: [
        { label: 'FAQ', href: '/about/faq' },
        { label: 'Contact Us', href: '/about/contact-us' },
        { label: 'Terms & Conditions', href: '/about/terms' },
        { label: 'Blog', href: '/blog/' },
        { label: 'Sitemap', href: '/about/sitemap' },
      ],
    },
    {
      title: 'Contact',
      items: [{ label: 'contact@right2hope.org', href: 'mailto:contact@right2hope.org' }],
    },
  ];

  return (
    <footer className="bg-primary pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-row gap-16 mb-12 flex-wrap">
          <div className="space-y-4">
            <LogoInverse size={50} />
            <p className="text-sm text-default-200 max-w-xs">
              Right2Hope is a 501(c)(3) nonprofit organization dedicated to connecting patients with
              experimental treatments.
            </p>
          </div>

          {columns.map(column => (
            <div key={column.title}>
              <h4 className="mb-4 text-sm font-semibold uppercase tracking-wide text-default-400">
                {column.title}
              </h4>
              <ul className="space-y-2">
                {column.items.map(item => (
                  <li key={item.href}>
                    <Link href={item.href} className={FOOTER_LINK_CLASSES}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-default-700 pt-8 text-center">
          <p className="text-sm text-default-300">
            &copy; {new Date().getFullYear()} Right2Hope. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
